import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  CreateDoRequestActionOutput,
} from '../../lib'
import {doREQUEST_COMPLETE, doREQUEST_ERROR, doSETTINGS_UPDATE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_IDENTITY_SETTINGS_UPDATE = 'REQUEST_IDENTITY_SETTINGS_UPDATE'

export interface IdentitySettingsUpdateRequestPayload {
  webAutoTimeoutLogoutEnabled: boolean
}
export const doREQUEST_IDENTITY_SETTINGS_UPDATE = createDoRequestAction<IdentitySettingsUpdateRequestPayload>(
  REQUEST_IDENTITY_SETTINGS_UPDATE,
)

export const requestIdentitySettingsUpdateActionCreators = {
  doREQUEST_IDENTITY_SETTINGS_UPDATE,
}

export function* requestIdentitySettingsUpdate(
  arg: CreateDoRequestActionOutput<IdentitySettingsUpdateRequestPayload>,
): SagaIterator {
  debug('saga*requestIdentityMfaEnabledUpdate')
  const {payload, setRequestResult} = arg

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        webAutoTimeoutLogoutEnabled: v.boolean().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_SETTINGS_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {webAutoTimeoutLogoutEnabled} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-settings-update`,
    accessToken,
    data: {
      webAutoTimeoutLogoutEnabled,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_SETTINGS_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-settings-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doSETTINGS_UPDATE({webAutoTimeoutLogoutEnabled}))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_SETTINGS_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* identitySettingsUpdateSaga() {
  yield takeEvery(REQUEST_IDENTITY_SETTINGS_UPDATE, requestIdentitySettingsUpdate)
}
